var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewStar = function SvgNewStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.60447L8.90991 11.3644C9.44281 11.687 10.0949 11.2102 9.95468 10.6072L9.18338 7.29757L11.7567 5.06781C12.2265 4.66112 11.9741 3.88982 11.357 3.84073L7.97033 3.55325L6.64509 0.425969C6.40669 -0.14199 5.59331 -0.14199 5.35491 0.425969L4.02967 3.54624L0.642956 3.83372C0.025914 3.88281 -0.226512 4.65411 0.243281 5.06079L2.81663 7.29056L2.04532 10.6001C1.90509 11.2032 2.55719 11.68 3.09009 11.3574L6 9.60447Z",
    fill: "black",
    fillOpacity: 0.7
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newStar.90d4cac6.svg";
export { ForwardRef as ReactComponent };